import { Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ObjectLookupComponent } from './object-lookup.component';
import { SupplierService } from 'app/server/services/supplier/supplier.service';

@Component({
  selector: 'app-supplier-object-lookup',
  templateUrl: './supplier-object-lookup.component.html',
  styleUrls: ['./object-lookup.component.scss']
})
export class SupplierObjectLookupComponent extends ObjectLookupComponent {
  constructor(private supplierService: SupplierService) {
    super();
  }

  protected loadObjectByIdFromService(id: number) {
    this.supplierService.getSupplierById(id).pipe(
      catchError(() => of(null))
    ).subscribe((result: any) => {
      this.isLoadingObject = false;
      if (result) {
        this.selectedObject = result;
        this.searchTerm = this.getObjectName(result);
        this.isSearching = false;
      } else {
        this.selectedObject = null;
        this.searchResults = [];
        this.searchTerm = '';
        this.isSearching = true;
      }
    });
  }

  public getObjectType(): string {
    return 'Supplier';
  }

  protected searchObjects(searchText: string): Observable<any[]> {
    if (!searchText) {
      return of([]);
    }

    return this.supplierService.searchSuppliers(searchText).pipe(
      catchError(() => of([]))
    );
  }

  public getObjectName(item: any): string {
    return item?.CompanyName ?? '';
  }

  public getObjectId(item: any): number | null {
    return item?.SupplierID;
  }
}
